{
  "name": "@aristobyte-ui/cli",
  "description": "The official AristoByteUI CLI — initialize projects, install, upgrade, remove, and manage UI components seamlessly.",
  "version": "1.0.110",
  "license": "MIT",
  "private": false,
  "author": "AristoByte <info@aristobyte.com>",
  "homepage": "https://www.npmjs.com/package/@aristobyte-ui/cli",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/aristobyte-team/aristobyte-ui.git",
    "directory": "./"
  },
  "bugs": {
    "url": "https://github.com/aristobyte-team/aristobyte-ui.git/issues"
  },
  "engines": {
    "node": ">=20.17.0",
    "npm": ">=10.8.2",
    "yarn": ">=1.22.22"
  },
  "keywords": [
    "aristobyte",
    "cli",
    "ui",
    "components",
    "typescript",
    "node",
    "developer-tools",
    "project-bootstrap",
    "package-management"
  ],
  "files": [
    "dist"
  ],
  "publishConfig": {
    "access": "public"
  },
  "main": "dist/index.js",
  "module": "dist/index.mjs",
  "bin": {
    "aristobyte-ui": "dist/index.js"
  },
  "exports": {
    ".": {
      "import": "./dist/index.mjs",
      "require": "./dist/index.js"
    }
  },
  "scripts": {
    "build": "tsup",
    "build:watch": "tsup ./index.ts --watch",
    "dev": "tsup && node ./bin/aristobyte-ui.js",
    "start": "node ./bin/aristobyte-ui.js",
    "lint": "eslint . --ext .ts,.tsx --max-warnings 0",
    "lint:fix": "eslint . --ext .ts,.tsx --fix",
    "check-types": "tsc --noEmit"
  },
  "dependencies": {
    "@aristobyte-ui/eslint-config": "^1.0.110",
    "@aristobyte-ui/typescript-config": "^1.0.110",
    "@clack/prompts": "^0.11.0",
    "axios": "^1.6.0",
    "chalk": "^5.6.1",
    "commander": "^11.0.0",
    "execa": "^8.0.0",
    "gradient-string": "^3.0.0"
  },
  "devDependencies": {
    "@changesets/changelog-github": "^0.5.1",
    "@changesets/cli": "^2.29.6",
    "@types/node": "^24.3.1",
    "eslint": "^9.35.0",
    "ts-node": "^10.9.2",
    "tsup": "^8.5.0",
    "typescript": "^5.9.2"
  }
}
